import type { BookingStatus } from "@bivak/domain";
import { nl } from "../../copy/nl.js";

/**
 * The status labels come from the same table the audit log uses (nl.status) —
 * one vocabulary, no parallel wording (sketch decision 4b). Colours follow the
 * sketch: amber only for the states with a clock on them.
 */
const CHIP: Record<BookingStatus, { className: string; dot: string }> = {
  enquiry: { className: "bg-[#e8e2f2] text-[#4c3a78]", dot: "bg-[#6a54a3]" },
  option: { className: "bg-[#f3e7ce] text-[#7c5510]", dot: "bg-amber" },
  confirmed: { className: "bg-[#dee8df] text-dennen-diep", dot: "bg-dennen" },
  stayed: { className: "bg-[#dbe4ea] text-[#31586e]", dot: "bg-[#41718d]" },
  settled: { className: "bg-[#e4e2da] text-[#5b5b4f]", dot: "bg-[#8b8b7a]" },
  closed: { className: "bg-[#e4e2da] text-[#5b5b4f]", dot: "bg-[#8b8b7a]" },
  declined: { className: "bg-zand text-mist", dot: "bg-mist" },
  expired: { className: "bg-zand text-mist", dot: "bg-mist" },
  cancelled: { className: "bg-zand text-mist", dot: "bg-mist" },
};

const NEUTRAL = { className: "bg-zand text-mist", dot: "bg-mist" };

export function StatusChip({ status, label }: { status: string; label?: string | undefined }) {
  const chip = (CHIP as Record<string, { className: string; dot: string }>)[status] ?? NEUTRAL;
  const text = label ?? (nl.status as Record<string, string>)[status] ?? status;
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 font-semibold text-[11.5px] ${chip.className}`}
    >
      <i className={`block h-1.5 w-1.5 rounded-full ${chip.dot}`} />
      {text}
    </span>
  );
}
